import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow\"><path d=\"M855.335 328.665c12.758 12.759 12.886 33.365.382 46.28l-.382.39-320 320c-12.759 12.758-33.365 12.886-46.28.382l-.39-.382-320-320c-12.887-12.888-12.887-33.782 0-46.67 12.759-12.758 33.365-12.886 46.28-.382l.39.382L512 625.331l296.665-296.666c12.759-12.758 33.365-12.886 46.28-.382l.39.382z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol